import { render, staticRenderFns } from "./SaleinvoicesOther.vue?vue&type=template&id=99d3c02a&"
import script from "./SaleinvoicesOther.vue?vue&type=script&lang=js&"
export * from "./SaleinvoicesOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports